"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchQuerySet = void 0;
const searchQuerySet = exports.searchQuerySet = {
  order: {
    start: ["name", "event", "pg", "birth", "death"],
    end: ["cursor"]
  },
  known: {
    name: {
      type: "name"
    },
    birth: {
      type: "event",
      group: "events",
      multiplicity: 1,
      modelName: "SelfBirth",
      properties: {
        relation: "Self",
        eventName: "Birth"
      }
    },
    marriage: {
      type: "event",
      group: "events",
      multiplicity: 1,
      modelName: "SelfMarriage",
      properties: {
        relation: "Self",
        eventName: "Marriage"
      }
    },
    death: {
      type: "event",
      group: "events",
      multiplicity: 1,
      modelName: "SelfDeath",
      properties: {
        relation: "Self",
        eventName: "Death"
      }
    },
    residence: {
      type: "event",
      group: "events",
      multiplicity: 10,
      modelName: "SelfResidence",
      properties: {
        relation: "Self",
        eventName: "Residence"
      }
    },
    military: {
      type: "event",
      group: "events",
      multiplicity: 1,
      modelName: "SelfMilitary",
      properties: {
        relation: "Self",
        eventName: "Military"
      }
    },
    departure: {
      type: "event",
      group: "events",
      multiplicity: 1,
      modelName: "SelfDeparture",
      properties: {
        relation: "Self",
        eventName: "Departure"
      }
    },
    arrival: {
      type: "event",
      group: "events",
      multiplicity: 1,
      modelName: "SelfArrival",
      properties: {
        relation: "Self",
        eventName: "Arrival"
      }
    },
    divorce: {
      type: "event",
      group: "events",
      multiplicity: 1,
      modelName: "SelfDivorce",
      properties: {
        relation: "Self",
        eventName: "Divorce"
      }
    },
    baptism: {
      type: "event",
      group: "events",
      multiplicity: 1,
      modelName: "SelfBaptism",
      properties: {
        relation: "Self",
        eventName: "Baptism"
      }
    },
    burial: {
      type: "event",
      group: "events",
      multiplicity: 1,
      modelName: "SelfBurial",
      properties: {
        relation: "Self",
        eventName: "Burial"
      }
    },
    event: {
      type: "event",
      group: "events",
      multiplicity: 10,
      modelName: "Self",
      properties: {
        relation: "Self",
        eventName: ""
      }
    },
    father: {
      type: "name",
      group: "family",
      multiplicity: 1
    },
    mother: {
      type: "name",
      group: "family",
      multiplicity: 1
    },
    parent: {
      type: "name",
      group: "family",
      multiplicity: 1
    },
    spouse: {
      type: "name",
      group: "family",
      multiplicity: 10
    },
    child: {
      type: "name",
      group: "family",
      multiplicity: 10
    },
    sibling: {
      type: "name",
      group: "family",
      multiplicity: 10
    },
    priority: {
      type: "string",
      default: "default"
    },
    passThroughData: {
      type: "string"
    },
    pcat: {
      type: "string",
      modelName: "parentCategory"
    },
    location: {
      type: "string[]"
    },
    types: {
      type: "types"
    },
    cursor: {
      type: "cursor",
      group: "page"
    },
    pg: {
      type: "int",
      group: "page",
      modelName: "number",
      default: 1,
      min: 1
    },
    count: {
      type: "int",
      group: "page",
      modelName: "size",
      default: 20,
      values: [0, 10, 20, 50]
    },
    viewMode: {
      type: "string",
      default: "record",
      values: ["record", "category"],
      canonical: false
    },
    treePerson: {
      format: "{treeId}_{personId}"
    },
    sort: {
      type: "string",
      default: "count",
      values: ["count", "label"]
    },
    race: {
      type: "stringWithExactness",
      group: "fields",
      modelName: "SelfRace",
      properties: {
        relation: "Self",
        eventName: "",
        assertion: "Race"
      }
    },
    keyword: {
      type: "stringWithExactness",
      group: "fields",
      modelName: "keyword",
      properties: {
        relation: "",
        eventName: "",
        assertion: "keyword"
      }
    },
    gender: {
      type: "gender",
      group: "fields",
      modelName: "SelfGender",
      properties: {
        relation: "Self",
        eventName: "",
        assertion: "Gender"
      }
    },
    timespan: {
      type: "yearRangeWithMatchMode",
      modelName: "timespan",
      properties: {
        relation: "Self",
        eventName: "Timespan",
        assertion: ""
      }
    },
    searchType: {
      type: "enum",
      values: {
        p: "person-picker",
        f: "form",
        t: "tree",
        b: "bbog",
        "quickfill-tiles": "quickfill-tiles",
        "quickfill-givenname": "quickfill-givenname",
        "quickfill-surname": "quickfill-surname",
        "searchassist-noselection": "searchassist-noselection",
        "searchassist-personselected": "searchassist-personselected",
        "searchassist-criteriaentered": "searchassist-criteriaentered",
        "searchassist-skippermanently": "searchassist-skippermanently",
        "searchassist-picker": "searchassist-picker",
        "searchassist-closed": "searchassist-closed",
        "searchassist-option": "searchassist-option",
        "searchassist-pickerskipped": "searchassist-pickerskipped",
        recent_home: "recent_home",
        recent_all: "recent_all",
        "search-mode-toggle": "search-mode-toggle"
      },
      default: "f"
    },
    birth_f: {
      type: "eventFilter",
      group: ["filters", "events"],
      modelName: "SelfBirth"
    },
    death_f: {
      type: "eventFilter",
      group: ["filters", "events"],
      modelName: "SelfDeath"
    },
    marriage_f: {
      type: "eventFilter",
      group: ["filters", "events"],
      modelName: "SelfMarriage"
    },
    residence_f: {
      type: "eventFilter",
      group: ["filters", "events"],
      modelName: "SelfResidence"
    },
    arrival_f: {
      type: "eventFilter",
      group: ["filters", "events"],
      modelName: "SelfArrival"
    },
    departure_f: {
      type: "eventFilter",
      group: ["filters", "events"],
      modelName: "SelfDeparture"
    },
    military_f: {
      type: "eventFilter",
      group: ["filters", "events"],
      modelName: "SelfMilitary"
    },
    record_f: {
      type: "eventFilter",
      group: ["filters"],
      modelName: "record"
    },
    image_f: {
      type: "string",
      group: ["filters"],
      modelName: "imageSubject"
    },
    documentType_f: {
      type: "string",
      group: ["filters"],
      modelName: "documentType"
    },
    imageSource_f: {
      type: "string",
      group: ["filters"],
      modelName: "imageSource"
    },
    debug: {
      type: "bool",
      default: false
    },
    eventType: {
      type: "enum",
      values: {
        birth: "birth",
        marriage: "marriage",
        death: "death"
      }
    },
    facetsOnly: {
      type: "string",
      group: ["filters"],
      default: ""
    },
    defaultFacets: {
      type: "string[]"
    },
    showUnviewedRecordsOnly: {
      type: "bool",
      default: false
    },
    useCanonicalUrl: {
      type: "bool",
      default: false
    },
    searchMode: {
      type: "enum",
      values: {
        simple: "simple",
        advanced: "advanced"
      }
    },
    skipVeiling: {
      type: "bool",
      default: false
    },
    include: {
      type: "enum",
      values: {
        refinements: "refinements",
        results: "results",
        all: "all"
      },
      default: "all"
    },
    refinements: {
      type: "refinements"
    },
    shouldShowDocTabExperimentalFacets: {
      type: "bool",
      default: false
    },
    recordSubject_f: {
      type: "enum",
      group: ["filters"],
      values: {
        all: "all",
        primary: "primary",
        secondary: "secondary"
      },
      default: "all",
      modelName: "recordSubject"
    },
    o_useYearRangeTaxonomies: {
      group: "options",
      modelName: "useYearRangeTaxonomies",
      type: "bool",
      default: false
    },
    o_reqOptimisationEnabled: {
      group: "options",
      modelName: "reqOptimisationEnabled",
      type: "bool",
      default: false
    }
  },
  dynamic: {
    "e-{relation}-{eventName}": {
      type: "event",
      group: "events",
      modelNameFormat: "{relation}{eventName}",
      multiplicity: 1
    },
    "f-{relation}-{eventName}-{assertion}": {
      type: "stringWithExactness",
      group: "fields",
      modelNameFormat: "{relation}{eventName}{assertion}"
    },
    "f-{relation}-{assertion}": {
      type: "stringWithExactness",
      group: "fields",
      modelNameFormat: "{relation}{assertion}",
      properties: {
        eventName: ""
      }
    },
    "f-{assertion}": {
      type: "stringWithExactness",
      group: "fields",
      modelNameFormat: "{assertion}",
      properties: {
        relation: "",
        eventName: ""
      }
    }
  },
  types: {
    treeId: {
      type: "string"
    },
    personId: {
      type: "string"
    },
    gender: {
      format: "{value}",
      suffix: {
        type: "isExact",
        keySuffix: "_x"
      },
      types: {
        value: {
          type: "enum",
          values: {
            m: "male",
            f: "female"
          }
        },
        isExact: {
          type: "bool"
        }
      }
    },
    types: {
      type: "flags",
      values: {
        r: "records",
        s: "stories",
        t: "trees",
        p: "photos"
      },
      default: "rstp"
    },
    name: {
      format: "{givenName}_{surname}_{secondSurname}",
      suffix: {
        type: "nameExactness",
        keySuffix: "_x"
      },
      types: {
        givenName: {
          type: "string"
        },
        surname: {
          type: "string"
        },
        secondSurname: {
          type: "string"
        },
        nameExactness: {
          format: "{givenNameExactness}_{surnameExactness}",
          types: {
            givenNameExactness: {
              type: "flagsOrBool",
              values: {
                p: "phonetic",
                s: "similar",
                i: "initials"
              },
              boolModelName: "isExact"
            },
            surnameExactness: {
              type: "flagsOrBool",
              values: {
                p: "phonetic",
                s: "similar",
                x: "soundex"
              },
              boolModelName: "isExact"
            }
          }
        }
      }
    },
    event: {
      type: "format",
      format: "{date}_{location}_{gpid}",
      suffix: {
        type: "eventExactness",
        keySuffix: "_x"
      },
      types: {
        date: {
          format: "{year}-{month}-{day}-{endYear}",
          types: {
            day: {
              type: "int",
              min: 1,
              max: 31
            },
            month: {
              type: "int",
              min: 1,
              max: 12
            },
            year: {
              type: "int",
              min: 1
            },
            endYear: {
              type: "int",
              min: 1
            }
          },
          note: "The year 1582 is the beginning of the Gregorian calendar.  To go earlier than this we should specify the calendar."
        },
        eventExactness: {
          format: "{dateProximity}_{locationExactness}",
          types: {
            dateProximity: {
              format: "{year}-{month}-{day}",
              types: {
                year: {
                  type: "int",
                  min: 0
                },
                month: {
                  type: "int",
                  min: 0,
                  max: 0
                },
                day: {
                  type: "int",
                  min: 0,
                  max: 0
                }
              }
            },
            locationExactness: {
              format: "{isExact}-{level}-{isAdjacent}",
              types: {
                isExact: {
                  type: "bool"
                },
                level: {
                  type: "int",
                  min: 0
                },
                isAdjacent: {
                  type: "bool",
                  composeTrueValue: "a"
                }
              }
            }
          }
        }
      }
    },
    location: {
      type: "escapedString",
      escapes: [{
        _: "__"
      }, {
        "-": "_~"
      }, {
        ", ": "-"
      }]
    },
    gpid: {
      type: "string"
    },
    yearRange: {
      format: "{yearStart}-{yearEnd}",
      types: {
        yearStart: {
          type: "int"
        },
        yearEnd: {
          type: "int"
        }
      }
    },
    yearRangeWithMatchMode: {
      format: "{yearStart}-{yearEnd}",
      suffix: {
        type: "matchMode",
        keySuffix: "_x"
      },
      types: {
        yearStart: {
          type: "int"
        },
        yearEnd: {
          type: "int"
        },
        matchMode: {
          type: "enum",
          values: {
            r: "rankOnly",
            m: "mustMatch"
          },
          default: "r"
        }
      }
    },
    cursor: {
      type: "escapedString",
      escapes: [{
        "~": "~~"
      }, {
        _: "~-"
      }, {
        "|": "_"
      }]
    },
    stringWithExactness: {
      format: "{value}",
      suffix: {
        type: "isExact",
        keySuffix: "_x"
      },
      types: {
        value: {
          type: "string"
        },
        isExact: {
          type: "bool"
        }
      }
    },
    eventFilter: {
      type: "format",
      format: "{date}_{location}",
      types: {
        date: {
          type: "format",
          format: "{start}-{end}",
          types: {
            start: {
              type: "int"
            },
            end: {
              type: "int"
            }
          }
        },
        location: {
          type: "format",
          format: "{gpid}",
          types: {
            gpid: {
              type: "string"
            }
          }
        }
      }
    },
    refinements: {
      type: "format",
      format: "{requestType}-{includeRefinements}",
      types: {
        requestType: {
          type: "enum",
          values: {
            n: "none",
            f: "flags",
            s: "set",
            a: "all"
          },
          default: "a"
        },
        includeRefinements: {
          type: "string[]",
          delimiter: ","
        }
      }
    }
  }
};